export default __webpack_public_path__ + "static/media/saia.ac61b250.webp";